import { html, LitElement } from 'lit-element';
import Cookies from 'js-cookie';

function userHasGivenCookieConsent() {
	const advertisingConsent = 'C5s2';

	const oneTrustCookie = Cookies.get('OptanonConsent');

	return oneTrustCookie?.includes('groups') && oneTrustCookie.includes(`${advertisingConsent}:1`);
}

class YoutubeVideo extends LitElement {
	static get properties() {
		return {
			videoId: { type: String },
			videoTitle: { type: String },
			imageSrc: { type: String },
			additionalProperties: { type: Object },
			_showVideo: { type: Boolean },
		};
	}

	constructor() {
		super();

		this.videoId = '';
		this.videoTitle = '';
		this.imageSrc = '';
		this.additionalProperties = {};
		this._showVideo = false;
		this._interval = null;
	}

	connectedCallback() {
		super.connectedCallback();

		this._showVideo = userHasGivenCookieConsent();

		this._interval = setInterval(() => {
			if (this._showVideo) {
				clearInterval(this._interval);
			} else {
				this._showVideo = userHasGivenCookieConsent();
			}
		}, 1000);
	}

	disconnectedCallback() {
		super.disconnectedCallback();

		clearInterval(this._interval);
	}

	render() {
		if (this._showVideo) {
			const url = new URL(`https://www.youtube-nocookie.com/embed/${this.videoId}`);

			url.searchParams.set('rel', '0');
			url.searchParams.set('enablejsapi', '1');
			url.searchParams.set('modestbranding', '1');
			url.searchParams.set('showinfo', '0');

			return html`<div class="iframe-container">
					<iframe title="Embedded YouTube video"
						class="iframe iframe--youtube js-youtube-video"
						src="${url.toString()}"
						allow="encrypted-media"
						allowfullscreen
					></iframe>
				</div>`;
		}

		const {
			privacyOverlayText = 'Once activated, data will be transferred to Google and YouTube, over which we have no control. Further information:',
			privacyOverlayLinkText = 'Privacy Policy',
			privacyOverlayActivateButtonText = 'Activate Video',
			privacyPolicyUrl = '',
		} = this.additionalProperties;

		return html`
			<div class="youtube-thumbnail__wrapper with-privacy-overlay"  tabindex="0">
				<div class="privacy-overlay">
					<div>
						${privacyOverlayText}
						<a href="${privacyPolicyUrl}" target="_blank" rel="noopener noreferrer">${privacyOverlayLinkText}</a>.
					</div>

					<button @click="${this.showVideo}" class="button">${privacyOverlayActivateButtonText}</button>
				</div>

				${this.imageSrc ? html`<img class="youtube-thumbnail" src="${this.imageSrc}" alt="${this.videoTitle}" />` : html`<div style='min-height: 240px;'></div>`}
				<img class="youtube-thumbnail__overlay" alt="Youtube Icon" src="/img/assets/youtube/youtube-logo.svg" />
			</div>
		`;
	}

	showVideo() {
		this._showVideo = true;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-youtube-video', YoutubeVideo);

export default YoutubeVideo;
